import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API_URL } from "../config";
import { useI18n } from "../i18n/I18nProvider";
import { SectionTitle } from "../i18n/SectionTitle";

function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [visibleBlogs, setVisibleBlogs] = useState(3);
  const [showMore, setShowMore] = useState({});
  const { t } = useI18n();

  const toggleShowMore = (index) => {
    setShowMore((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const loadMoreBlogs = useCallback(() => {
    setVisibleBlogs((prevVisibleBlogs) => {
      if (blogs.length === 0) return prevVisibleBlogs;
      return Math.min(prevVisibleBlogs + 3, blogs.length);
    });
  }, [blogs.length]);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        loadMoreBlogs();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [blogs, loadMoreBlogs]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/blogs`)
      .then((response) => {
        setBlogs(response.data);
      })
      .catch((error) => {
        console.error("Error fetching blogs:", error);
      });
  }, []);

  return (
    <div className="blog-page-modern">
      <div className="contact_section layout_padding blog-page-modern__section">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <SectionTitle
                beforeKey="blog.title"
                afterKey="blog.titleAccent"
                className="blog_taital"
              />
              <p className="blog_text blog-page-modern__intro">{t("blog.intro")}</p>
            </div>
          </div>
        </div>

        <div className="blog_section_2 blog-page-modern__grid-wrap">
          <div className="container">
            <div className="row blog-page-modern__row">
              {blogs.slice(0, visibleBlogs).map((blog, index) => (
                <div
                  className="col-lg-4 col-md-6 col-sm-12 blog-page-modern__col"
                  key={`${blog.title}-${index}`}
                >
                  <article className="blog-card">
                    <div
                      className={`blog-card__cover ${blog.class}`}
                      role="img"
                      aria-hidden
                    >
                      <span className="blog-card__date">
                        {t("blog.postedOn")} {blog.date}
                      </span>
                    </div>
                    <div className="blog-card__body">
                      <h3 className="blog-card__title">{blog.title}</h3>
                      <p className="blog-card__excerpt">
                        {showMore[index]
                          ? blog.text
                          : `${blog.text.slice(0, 140).trim()}…`}
                      </p>
                      <button
                        type="button"
                        onClick={() => toggleShowMore(index)}
                        className="blog-card__toggle pro-btn pro-btn--primary"
                      >
                        {showMore[index] ? t("blog.seeLess") : t("blog.seeMore")}
                      </button>
                    </div>
                  </article>
                </div>
              ))}
            </div>
            {visibleBlogs < blogs.length && (
              <p className="blog-page-modern__load-hint">{t("blog.scrollLoad")}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog;
